module.exports = __webpack_public_path__ + "media/images/icons/duotone-icons/Layout/Layout-right-panel-1-cd57d7c73ab32e4f33b805e9a106bcb5.svg";